import {addMessage} from "./addMessage";
import {responses} from "./responses";
import {updateOptions} from "./upgradeOptions";
import {showLoader} from "./showLoader";
import {hideChatOptions} from "./hideChatOptions";
import {hideLoader} from "./hideLoader";
import {showChatOptions} from "./showChatOptions";
export const msg = {
	count: 0,
	maxFree: 3
}
export function handleOptionClick(optionText, responseKey) {
	const chatMessages = document.getElementById('chat-messages');
	const upgradeModal = document.getElementById('upgrade-modal');

	msg.count++;
	addMessage(optionText, true);
	showLoader()
	hideChatOptions();
	setTimeout(() => {
		 if (responses[responseKey]) {
			addMessage(responses[responseKey].text);
			if (responses[responseKey].options) {
				updateOptions(responses[responseKey].options);
				showChatOptions();
			} else {
				chatMessages.classList.add('h-[394px]');
				chatMessages.classList.remove('h-[150px]');
				setTimeout(() => {
					upgradeModal.classList.remove('hidden');

				}, 3000)
			}
			hideLoader();
		}
	}, 1500);
}
